import React from 'react'
import { Tooltip } from '@material-ui/core'

export default function Marker(props) {
  function handleLocationChange() {
    if (!props.clickDisabled) {
      props.setSearchLocation({
        value: props.address.value,
        label: props.address.label
      })
    }
  }

  return (
    <Tooltip title={(
      <div>
        <div>{props.address?.value?.name || props.address?.label || ''}</div>
        {props.address?.value?.crewNames?.map((name, idx) => <div key={idx}>{name}</div>)}
        {props.address?.value?.acres}
      </div>
    )}
    >
      <div
        style={{
          width: '15px',
          height: '15px',
          borderRadius: '50% 50% 50% 0',
          background: props.color,
          position: 'absolute',
          transform: 'rotate(-45deg)',
          left: '50%',
          top: '50%',
          margin: '-20px 0 0 -20px',
          border: '2px solid black',
        }}
        onClick={handleLocationChange}
      >
        <div style={{
          width: '7px',
          height: '7px',
          margin: '4px 0 0 4px',
          background: '#fff',
          position: 'absolute',
          borderRadius: '50%',
          border: '1px solid black',
          boxSizing: 'border-box',
        }}
        >
        </div>
      </div>
    </Tooltip>
  )
}